// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MyJz7","title":"styles_title__1fhaT"};